import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import TablerWrapper from '@components/auntification/tablerWrapper';
import { AUTH_OFFSET_BACK_FORM } from '@components/auntification/tablerWrapper/constants';
import Button from '@components/button/index';
import Input from '@components/input/index';
import Logo from '@components/logo/index';
import { navigateTo, navigateBack, isPhone } from '@helpers';
import { forgotPassword } from '@reducers/user';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import useStatusBar from '@components/common/useStatusBar';
import { scale } from '@components/frame';

const ForgotPass = (props) => {
  const { forgotPassword, C, route } = props;

  const getParams = (name) => {
    return (route && route.params && route.params[name]) || false;
  };

  const defaultEmail = getParams('email');

  const [isValid, setIsValid] = useState(true);
  const [email, setEmail] = useState(defaultEmail || '');
  const [loading, setLoading] = useState(false);
  useStatusBar({ C });

  const submit = async () => {
    setLoading(true);
    await forgotPassword({ emailAddress: email }, () => navigateTo('ConfirmCode', { data: { email }, scenario: 'password' }));
    setLoading(false);
  };

  const toLogin = () => {
    navigateBack();
  };

  return (
    <TablerWrapper offset={AUTH_OFFSET_BACK_FORM} keyboardAvoid={!isPhone}>
      <Logo {...{ isBack: true, title: i18n.t('Forgot password') }} />
      <View style={{ width: '100%' }}>
        <View style={{ marginBottom: scale(15) }}>
          <Input
            placeholder={i18n.t('Email address')}
            valid={isValid}
            errorText="Error"
            onChangeText={setEmail}
            value={email}
            autoCompleteType="email"
          />
        </View>
        <Button
          {...{
            name: i18n.t('Send reset code'),
            disabled: !email,
            onPress: submit,
            loading,
          }}
        />
        <TouchableOpacity style={styles.loginQRBox} onPress={toLogin}>
          <Text style={[styles.loginQRText, { color: C('Label / Light / Tertiary') }, font['Button 2']]}>{i18n.t('I already have an account')}</Text>
        </TouchableOpacity>
      </View>
    </TablerWrapper>
  );
};
export default connect(null, { forgotPassword })(ColorWrapper(ForgotPass));

const styles = StyleSheet.create({
  inputContainer: {
    width: '90%',
    justifyContent: 'center',
    marginBottom: 15,
  },
  loginQRBox: {
    marginTop: 26,
  },
  loginQRText: {
    fontWeight: '500',
    fontSize: 13,
    textAlign: 'center',
  },
});
